import React from "react";
import { Button, Dropdown, Form } from "react-bootstrap";
import BsFilter from "../../../../../../constants/icons/Bs/BsFilter";

const SubjectFilter = ({ subjects, filteredSubjects, handleFilterChange }) => {
  return (
    <div className="filter-section p-4">
      <Dropdown className="filter-dropdown">
        <Dropdown.Toggle variant="light" className="filter-button">
          <div className="filter-button-content">
            <BsFilter className="filter-icon" />
            <span className="filter-text ms-2">Filter by Subject</span>
            {filteredSubjects.length > 0 && (
              <span className="filter-badge ms-2">
                {filteredSubjects.length}
              </span>
            )}
          </div>
        </Dropdown.Toggle>
        <Dropdown.Menu className="filter-menu" align="end">
          <div className="filter-menu-header">
            <div className="filter-menu-title">
              <BsFilter className="filter-menu-icon" />
              <h5>Filter Subjects</h5>
            </div>
            {filteredSubjects.length > 0 && (
              <Button
                variant="link"
                size="sm"
                className="clear-all"
                onClick={() => handleFilterChange([])}
              >
                Clear All
              </Button>
            )}
          </div>
          <div className="filter-menu-divider" />
          <div className="filter-options">
            {subjects.map((subject) => (
              <div key={subject._id} className="filter-option">
                <Form.Check
                  type="checkbox"
                  id={`subject-${subject._id}`}
                  label={subject.name}
                  checked={filteredSubjects.includes(subject._id)}
                  onChange={() => handleFilterChange(subject._id)}
                  className="custom-checkbox"
                />
              </div>
            ))}
          </div>
        </Dropdown.Menu>
      </Dropdown>
    </div>
  );
};

export default SubjectFilter;
